<template>
    <div class="area-logada-filtro-container" id="area-logada-filtro-container">
        <span class="d-none d-xl-block">Preencha um dos campos para buscar em sua lista.</span>
            <b-form name="filtroFormContainer" id="area-logada-filtro-form-container" ref="areaLogadaFiltroForm" v-show="!mobile || filtrarMobile">
                <b-link class="btn-voltar-filtros d-xl-none" @click="voltarFiltro">
                    Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                </b-link>
                <span class="d-xl-none">Preencha um dos campos para buscar em sua lista.</span>
                <div class="area-logada-filtro-btn-container">
                    <b-button class="btn-limpar-filtros d-xl-none" @click="limparFiltroMobile">
                        <svg style="color: #5cb3ff;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10.83,8H21V6H8.83L10.83,8z M15.83,13H18v-2h-4.17L15.83,13z M14,16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h0.17 L1.39,4.22l1.41-1.41l18.38,18.38l-1.41,1.41L14,16.83z" fill="#597eb5"></path></svg>
                        Limpar filtro
                    </b-button>
                    
                </div>
                <!-- Quando for Cancelamento -->
                <!-- Quando for Certidao -->
                <b-form-group
                    v-if="!['aprovadas'].includes(page)"
                    label="Número do pedido:"
                    label-for="nrPedido"
                    id="nrPedidoGroup"
                >
                    <b-form-input 
                    id="nrPedido"
                    v-model="filtros.nrPedido"
                    placeholder="Número do pedido"
                    class="form-control"></b-form-input>
                </b-form-group>
                <!-- Nº Pedido Protesto — apenas PedidoRetirada -->
                <b-form-group
                    v-if="['PedidoRetirada'].includes(page)"
                    label="Nº Pedido Protesto:"
                    label-for="cdPedidoProtesto"
                    id="cdPedidoProtestoGroup"
                >
                    <b-form-input
                    id="cdPedidoProtesto"
                    v-model="filtros.cd_pedido_protesto"
                    placeholder="Nº Pedido Protesto"
                    class="form-control"></b-form-input>
                </b-form-group>
                <!-- <b-form-group
                    v-if="['aprovadas'].includes(page)" 
                    label="Nome do cobrador:"
                    label-for="nomeCobrador"
                    id="nomeCobradorGroup"
                >
                    <b-form-input 
                    id="docCobrador"
                    v-model="filtros.docCobrador"
                    placeholder="Nome do cobrador"
                    class="form-control"></b-form-input>
                </b-form-group> -->
                <b-form-group
                    v-if="!(['PedidoRetirada'].includes(page))"
                    :label="(['Certidao'].includes(page) ? 'Nome do pesquisado:' : 'Nome do devedor:')"
                    label-for="nm_devedor"
                    id="nomeDevedorGroup"
                >
                    <b-form-input 
                    id="nm_devedor"
                    v-model="filtros.nm_devedor"
                    placeholder="Nome do devedor"
                    class="form-control"></b-form-input>
                </b-form-group>
                <b-form-group
                    v-if="!(['PedidoRetirada'].includes(page))"
                    :label="(['Certidao'].includes(page) ? 'Documento do pesquisado:' : 'Documento do devedor:')"
                    label-for="docDevedor"
                    id="docDevedorGroup"
                >
                    <the-mask
                        :mask="[mask.cpf,mask.cnpj]"
                        id="docDevedor"
                        v-model="filtros.nm_nr_identificacao_devedor"
                        class="form-control"
                        placeholder="XXXXXXXXX"/>
                </b-form-group>
                <!-- Quando não for Aprovadas -->
                <!-- Quando não for Certidao -->
                <!-- Quando não for Cancelamento -->
                <b-form-group
                    v-if="!(['aprovadas','Certidao','Cancelamento','PedidoRetirada'].includes(page))"
                    label="Nosso número:"
                    label-for="nossoNumero"
                    id="nossoNumeroGroup"
                >
                    <b-form-input 
                    id="nossoNumero"
                    v-model="filtros.nm_nosso_numero"
                    placeholder="XXXXXXXXX"
                    number
                    class="form-control"></b-form-input>
                </b-form-group>
                <b-form-group
                    v-if="!['resolve'].includes(page)"
                    :label="!(['aprovadas','Certidao','Cancelamento'].includes(page)) ? 'Data solicitação início:' : 
                                (['Certidao','Cancelamento'].includes(page))? 'Data inicial:' : 'Data solicitação:'"
                    label-for="dtEmissao"
                    id="dtEmissaoGroup"
                >
                    <b-form-input 
                    id="dtEmissao"
                    v-model="filtros.dt_cadastro"
                    placeholder="DD/MM/AAAA"
                    type="date"
                    class="form-control"></b-form-input>
                </b-form-group>
                <!-- Quando não for Aprovadas -->
                <b-form-group
                    v-if="!(['aprovadas','resolve'].includes(page))"
                    :label="(['Certidao','Cancelamento'].includes(page))? 'Data final:' : 'Data solicitação fim:'"
                    label-for="dtVencimento"
                    id="dtVencimentoGroup"
                >
                    <b-form-input 
                    id="dtVencimento"
                    v-model="filtros.dtVencimento"
                    placeholder="DD/MM/AAAA"
                    type="date"
                    class="form-control"></b-form-input>
                </b-form-group>
                <!-- Quando não for Aprovadas -->
                <!-- Quando não for Certidao -->
                <!-- Quando não for Cancelamento -->
                <b-form-group
                    v-if="!(['Renegociacao','aprovadas','Certidao','Cancelamento','PedidoRetirada'].includes(page))"
                    label="Ocorrência"
                    label-for="ocorrencia"
                    id="ocorrenciaGroup"
                >
                    <b-form-select
                        id="ocorrencia"
                        v-model="filtros.ocorrencia"
                        :options="listaOcorrencias"
                    ></b-form-select>
                </b-form-group>
                <!-- Quando não for Certidao -->
                <b-form-group 
                    v-if="!(['Certidao','PedidoRetirada'].includes(page))"
                    label="Nº Título:"
                    label-for="numero"
                    id="numeroGroup"
                >
                    <b-form-input 
                    id="numero"
                    v-model="filtros.nm_nr_titulo"
                    placeholder="Nº Título"
                    class="form-control"></b-form-input>
                </b-form-group>
                <!-- Quando não for Aprovadas -->
                <!-- Quando não for Certidao -->
                <b-form-group
                    v-if="!(['aprovadas','Certidao','PedidoRetirada'].includes(page))"
                    label="Valor do título:"
                    label-for="vlTitulo"
                    id="vlTituloGroup"
                >
                    <b-form-input 
                    id="vlTitulo"
                    v-model.number="filtros.vl_titulo"
                    placeholder="R$ 0,00"
                    @keyup="currencyFormat"
                    class="form-control"></b-form-input>
                </b-form-group>
                <!-- Quando não for Aprovadas -->
                <!-- Quando não for Certidao -->
                <b-form-group
                    v-if="!(['aprovadas','Certidao','PedidoRetirada'].includes(page))"
                    :label="(['Cancelamento'].includes(page)) ? 'Valor protestado:' : 'Valor a protestar:'"
                    label-for="vlProtestar"
                    id="vlProtestarGroup"
                >
                    <b-form-input 
                    id="vlProtestar"
                    v-model.number="filtros.vl_saldo"
                    placeholder="R$ 0,00"
                    @keyup="currencyFormat"
                    class="form-control"></b-form-input>
                </b-form-group>
                <div class="area-logada-filtro-btn-container">
                    <b-button class="btn-buscar d-xl-none" @click="filtrarBuscaMobile">Buscar</b-button>
                </div>
            </b-form>
            <div class="area-logada-filtro-btn-container">
                <b-button v-if="['VisualizarPedidoProtesto'].includes(page)" class="btn-exportar-busca" @click="exportarBusca">
                    <img src="~@/assets/imgs/icons/xlsx_logo.svg" />Exportar Planilha
                </b-button>
                <b-button class="btn-limpar-filtros" @click="limparFiltro">
                    <svg style="color: #5cb3ff;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10.83,8H21V6H8.83L10.83,8z M15.83,13H18v-2h-4.17L15.83,13z M14,16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h0.17 L1.39,4.22l1.41-1.41l18.38,18.38l-1.41,1.41L14,16.83z" fill="#597eb5"></path></svg>
                    Limpar filtro
                </b-button>
                <b-button v-if="!mobile" class="btn-buscar" @click="filtrarBusca">Buscar</b-button>
                <b-button v-else class="btn-buscar-filtros" @click="openFiltroModal">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/></svg>
                    Filtrar busca
                </b-button>
            </div>
    </div>
</template>
<script>
import { TheMask } from "vue-the-mask";
import API from '../../../../services/api';

    export default {    
        props:{
            page: String
        },
        components: {
            TheMask,
        },
        data() {
            return {
                listaOcorrencias:[],
                filtros:{
                    nm_devedor:'',
                    nm_nr_identificacao_devedor:'',
                    ocorrencia:'',
                    nm_nr_titulo:'',
                    nm_nosso_numero:'',
                    dt_cadastro:'',
                    dt_vencimento:'',
                    vl_titulo:'',
                    vl_saldo:'',
                    nomeCobrador:'',
                    docCobrador:'',
                    nrPedido:'',
                    status:'',
                    cd_pedido_protesto:'',
                },
                statusPedido: [{ text: 'Selecione', value: null }],
                activeFilters:{},
                mask:{
                    cpf:'###.###.###-##',
                    cnpj:'##.###.###/####-##',
                },
                filtrarMobile: false,
                mobile: window.innerWidth < 1200,
            }
        },
        methods: {
            async buscarOcorrencias() {
                const token = localStorage.getItem("jwtToken");
                API.post("protesto/listaOcorrencias", { token }).then((res) => {
                    this.listaOcorrencias.push({ value: "", text: "Ocorrências", disabled: true });
                    this.listaOcorrencias.push({ value: "Z", text: "Todos" });
                    for (const ocorrencia of res.data.ocorrencias) {
                        this.listaOcorrencias.push({
                            value: ocorrencia.sg_ocorrencia,
                            text: ocorrencia.nm_descricao,
                        });
                    }
                }).catch((err) => console.log(err));
            },
            async buscarStatus(){
                const token = localStorage.getItem("jwtToken");
                API.get(`certidao/listaStatusPedido?token=${token}`).then((res) => {
                    this.statusPedido = res.data
                })
            },
            removeFilter(filter){
                this.filtros[filter] = '';
                this.filtrarBusca();
            },
            setActiveFilters(){
                this.activeFilters = {};
                Object.keys(this.filtros).forEach(key => {
                    if(this.filtros[key] !== ''){
                        if(key === 'vl_titulo' || key === 'vlProtestar' || key === 'vl_saldo') this.activeFilters[key] =  this.currencyStringToNumber(this.filtros[key]);
                        else this.activeFilters[key] = this.filtros[key];
                    }
                });
            }, 
            currencyStringToNumber(currency){
                let valor = String(currency);
                valor = valor.replace(/[\D]+/g, "").replace(/^0+/, '');
                valor = valor.replace(/([0-9]{2})$/g, ".$1");
                return Number(valor);
            },
            currencyFormat: function (event) {
                let valor = String(event.target.value);
                valor = valor.replace(/[\D]+/g, "").replace(/^0+/, '');
                if (valor != "") {
                    valor = valor + "";
                    valor = valor.replace(/[\D]+/g, "");
                    valor = valor + "";
                    if(valor.length <= 3) valor = valor.padStart(3, '0');
                    valor = valor.replace(/([0-9]{2})$/g, ",$1");
                    valor = valor.replace(/(\d)(\d{3}),/g, "$1.$2,");
                    valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2"); //Coloca o resto dos pontos
                    valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
                    valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
                    valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
                } else {
                    valor = "";
                }
                event.target.value = "R$ " + valor;
            },
            limparFiltro(){
                this.$refs.areaLogadaFiltroForm.reset();
                Object.keys(this.filtros).forEach(key => {
                    this.filtros[key] = '';
                });
                this.activeFilters = {};
                this.$emit('limparFiltro',this.activeFilters);
            },
            exportarBusca(){
                this.setActiveFilters();
                this.$emit('exportarBusca', this.activeFilters);
            },
            filtrarBusca(){
                this.setActiveFilters();
                this.$emit('filtroBusca', this.activeFilters);
            },
            limparFiltroMobile(){
                this.limparFiltro();
                this.filtrarMobile = false;
                document.body.classList.remove('noscroll');
            },
            voltarFiltro(){
                this.filtrarMobile = false;
                document.body.classList.remove('noscroll');
            },
            filtrarBuscaMobile(){
                this.filtrarBusca();
                this.filtrarMobile = false;
                document.body.classList.remove('noscroll');
            },
            openFiltroModal(){
                this.filtrarMobile = true;
                document.body.classList.add('noscroll');
            }
        },
        mounted() {
            this.buscarOcorrencias();
            this.buscarStatus();
            if(this.page != 'aprovadas')this.filtrarBusca();
            this.$emit('setHeight',Number(document.getElementById('area-logada-filtro-container').offsetHeight));
        },
        computed:{
        },
        
    }
</script>
<style>
.area-logada-filtro-container{display:flex;flex-flow: column;width: 100%;height: fit-content;padding-bottom: 21px;border-bottom: 1px solid #F1F1F1;}
    .area-logada-filtro-container span{text-align: left;font: normal normal 200 16px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);margin-bottom: 25px;}
    
    .area-logada-filtro-container .area-logada-filtro-btn-container{display: flex;justify-content: flex-end;width: 100%;}
        .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-buscar{width: fit-content;height: 49px;border:none;background: var(--primary-color) 0% 0% no-repeat padding-box !important;border-radius: 40px;text-align: center;font: normal normal 400 20px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: #FFFFFF;padding: 0 30px;}
                /* .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-buscar:hover{background: #FFFFFF 0% 0% no-repeat padding-box !important;color: #4780F1;} */
        .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-limpar-filtros{display:flex;align-items:center;transition: all 0.2s ease-in;width: fit-content;height: 49px;background: #FFFFFF 0% 0% no-repeat padding-box !important;border: 3px solid var(--primary-color);border-radius: 40px;font: normal normal 400 20px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--primary-color);margin-right: 28px;}
                /* .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-limpar-filtros:hover{transition: all 0.2s ease-in;background: #597EB5 0% 0% no-repeat padding-box !important;color: #ffffff;} */
            .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-limpar-filtros svg{height: 30px;width: 30px;fill: var(--primary-color);margin-right: 2px;}
                /* .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-limpar-filtros:hover svg path{fill:#FFFFFF;transition: fill 0.2s ease-in;} */

        .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-buscar-filtros{display:flex;align-items:center;transition: all 0.2s ease-in;width: fit-content;height: 49px;background: var(--dark-gray-color) 0% 0% no-repeat padding-box !important;border: none;border-radius: 40px;font: normal normal 400 20px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: #ffffff;padding:0 30px;}
                /* .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-buscar-filtros:hover{transition: all 0.2s ease-in;background: #ffffff 0% 0% no-repeat padding-box !important;color: #4780F1;} */
            .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-buscar-filtros svg{height: 30px;width: 30px;fill: #ffffff;margin-right: 2px;}
                /* .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-buscar-filtros:hover svg path{fill:#4780F1;transition: fill 0.2s ease-in;} */
            
            .area-logada-filtro-container .area-logada-filtro-btn-container button:hover,
            .area-logada-filtro-container .area-logada-filtro-btn-container button:focus,
            .area-logada-filtro-container .area-logada-filtro-btn-container button:active {box-shadow: none !important;}
            .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-exportar-busca {
                display: flex;
                align-items: center;
                width: fit-content;
                height: 49px;
                background: #1ACEB5 0% 0% no-repeat padding-box;
                border-radius: 40px;
                opacity: 1;
                font: normal normal 400 20px/20px 'Kanit', sans-serif;
                letter-spacing: -1%;
                color: #ffffff;
                margin-right: 28px;
                border: none;
                padding:0 30px;
            }
            .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-exportar-busca img{height: 20px;margin-right: 6px;}
            /* .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-exportar-busca:active{background: #1ACEB5 0% 0% no-repeat padding-box;} */
 #area-logada-filtro-form-container{
    display: flex;
    flex-wrap: wrap;
    gap: 18px 41px;
    margin-bottom: 24px;
 }
 #area-logada-filtro-form-container .form-group{
    flex-grow: 1;
    margin-bottom: 0;
 }
 #area-logada-filtro-form-container .form-group input,
 #area-logada-filtro-form-container .form-group select{background: #F1F1F1 0% 0% no-repeat padding-box;border: 1px solid var(--light-gray-color);max-height:  48px;font: normal normal 400 20px/20px 'Kanit', sans-serif; letter-spacing: -1%;border-radius: 40px;padding: 0 30px;}
 #area-logada-filtro-form-container .form-group input:focus,
 #area-logada-filtro-form-container .form-group select:focus {box-shadow: none;}
 #area-logada-filtro-form-container .form-group input::placeholder,
 #area-logada-filtro-form-container .form-group select::placeholder {color: var(--secondary-color);}
 #area-logada-filtro-form-container .form-group label {font: normal normal 200 16px/17px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);margin-bottom: 11px;margin-left: 30px;}

 #area-logada-filtro-form-container .form-group select::-webkit-scrollbar{width: 5px;}
 #area-logada-filtro-form-container .form-group select::-webkit-scrollbar-track{background-color: #F1F1F1;}
 #area-logada-filtro-form-container .form-group select::-webkit-scrollbar-thumb{background-color: #A8A8A8;}
 #area-logada-filtro-form-container .form-group select::-webkit-scrollbar-thumb:hover{background-color: #8c8c8c;}

 #area-logada-filtro-form-container .form-group#ocorrenciaGroup::after{
  content: '';
  width: 0px;
  height: 0px;
  background: #597EB5 0% 0% no-repeat padding-box;
  z-index: 100;
  display: flex;
  position: relative;
  left: calc(100% - 14px - 10px);
  bottom: calc((35px)/2 + 3px);
  border-top: 5px solid #597EB5;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}

#nomeCobradorGroup{flex: 1 1 25.30%;}
#nomeDevedorGroup{flex: 1 1 25.30%;}
#ocorrenciaGroup{flex: 1 1 20%;}
#docCobradorGroup{flex: 1 1 20%;}
#docDevedorGroup{flex: 1 1 20%;}
#numeroGroup{flex: 1 1 25.30%;}
#nossoNumeroGroup{flex: 1 1 19.5%;}
#dtEmissaoGroup{flex: 1 1 13.9%;}
#dtVencimentoGroup{flex: 1 1 13.9%;}
#vlTituloGroup{flex: 1 1 19.8%;}
#vlProtestarGroup{flex: 1 1 19.8%;}
.form-group{flex: 1 1 auto !important;}
@media (max-width:1199px) {
    #area-logada-filtro-form-container{position: absolute;width: 100vw;height: calc(100vh - 68px - 1px);z-index: 1000;background-color: #ffffff;top: 1px;left: 0;padding: 23px 20px;flex-flow: column;gap:12px;align-items: center;overflow: overlay;}
    #area-logada-filtro-form-container::-webkit-scrollbar{width: 17px;}
    #area-logada-filtro-form-container::-webkit-scrollbar-track{background:transparent;}
    #area-logada-filtro-form-container::-webkit-scrollbar-thumb{background-color: #707070;border-left: 7px solid transparent;border-right: 7px solid transparent;background-clip: padding-box;border-radius: 72px;
                border-bottom: 8px solid transparent;border-top: 8px solid transparent;}
    #area-logada-filtro-form-container > *{flex:unset;flex-grow: unset !important;width: 100%;justify-content: center;}
    #area-logada-filtro-form-container .btn-limpar-filtros {margin: 0;}
    #area-logada-filtro-form-container .btn-buscar {margin-top: 22px;width: 100%;}
    #area-logada-filtro-form-container > span {text-align: center;}
    .btn-voltar-filtros{display: flex;align-items: center;margin-left: auto;font: normal normal bold 18px/20px 'Kanit', sans-serif;letter-spacing: 0px;color: #597EB5;text-decoration: none;justify-content: flex-end !important;margin-bottom: 20px;}
    .btn-voltar-filtros img{width: 20px; height: 20px;margin-left: 6px;}
    .area-logada-filtro-container .area-logada-filtro-btn-container{flex-wrap: wrap;gap: 10px 10px;}
    .area-logada-filtro-container .area-logada-filtro-btn-container button{margin: 0 !important;}

}
@media (max-width:555px) {
    .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-exportar-busca{width: 100%;}
    .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-limpar-filtros{width: 100%;}
    .area-logada-filtro-container .area-logada-filtro-btn-container button.btn-buscar-filtros{width: 100%;}
}

</style>
    
